import { VideoSection, Coaching } from '@kinomap-dev/ng-ui-lib';
import { Playlist } from '@kinomap-dev/ng-ui-lib/lib/models/playlist.model';

export class SearchedContentState {
  searchedContents: VideoSection[] | Coaching[] = [];
  isLoadingSearchedContents: boolean = false;
  areSearchedContentsComplete: boolean = false;
  searchedPlaylists: Playlist[] = [];
  isLoadingSearchedPlaylists: boolean = false;
  areSearchedPlaylistsComplete: boolean = false;
}
